import { lockScroll, unlockScroll } from 'JS/utils/lock-screen';

class AdvertisingModal {
    constructor(modal) {
        this.modal = modal;
        this.dateStorageKey = 'advertising-banner-date';
        this.showedDate = localStorage.getItem(this.dateStorageKey);
        this.closeBtns = this.modal.querySelectorAll('[data-close]');
        this.startDate = this.modal.getAttribute('data-start-date');
        this.init();
    }

    init() {
        
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); 
        const yyyy = today.getFullYear();
        const currentDate = yyyy + mm + dd;

        if (this.showedDate === this.startDate ) {
            return;
        }

        if (currentDate < this.startDate) {
            return;
        }

        this.openModal();
        this.addListeners();
    }

    addListeners() {
        this.closeBtns.forEach(el => {
            el.addEventListener('click', () => {
                this.closeModal();
            });
        })
    }

    openModal() {
        setTimeout(() => {
            lockScroll();
            this.modal.classList.add('banner--open');
        }, 2000); 
    }

    closeModal() {
        localStorage.setItem(this.dateStorageKey, this.startDate);
        this.modal.classList.remove('banner--open');
        unlockScroll();
    }
}

const advertisingModals = document.querySelectorAll('.banner');

advertisingModals.forEach(el => {
    new AdvertisingModal(el);
});
